import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../../store/authStore";
import useDroneStore from "../../../store/droneStore";
import { deletePilot } from "../../../api/authAPI";
import { capitalize } from "../../../helpers/commonFunction";
import { useEffect } from "react";

const DeletePilotConfirmationModal = ({ name, email, userId }) => {
    const { token, setLoaderState } = useAuthStore((state) => state);
    const qClient = useQueryClient();
    const { setShowPilotModal } = useDroneStore((state) => state);


    const deleteUserQuery = useMutation({
        mutationFn: deletePilot,
        onSuccess: () => {
            // refetch on submit
            setLoaderState(false)
            qClient.invalidateQueries({ queryKey: "getAllUser" });
        },
    })

    const deleteUserFunc = (userId) => {
        deleteUserQuery.mutate({ token, userId })
    }
    return (
        <>
            <div className="grid place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur-sm inset-0">
                <div id="defaultModal" className="p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                    <div className="relative w-full max-w-3xl max-h-fit">
                        <div className="relative bg-white rounded-lg dark:bg-white" onBlur={() => { setShowPilotModal(false) }}>
                            <div className="p-4 w-full border-b">
                                <div className="text-end">
                                    <button onClick={() => { setShowPilotModal(false) }} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="defaultModal">
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                        <span className="sr-only">Close modal</span>
                                    </button>
                                </div>
                                <div className="text-center p-4 text-tblu">
                                    <p className="text-xl">Do you really want to delete {capitalize(name)} ?</p>
                                </div>
                            </div>
                            <div className="flex items-center justify-end p-2">

                                <div className="space-x-2">

                                    <button onClick={() => {
                                        setShowPilotModal(false);
                                    }}
                                        type="button"
                                        className="inline-block bg-white border border-tblu rounded-lg text-tblu px-4 py-2.5 text-md font-medium capitalize leading-normal">
                                        <div className="flex items-center">
                                            <span> Cancel</span>
                                        </div>
                                    </button>
                                    <button onClick={() => { deleteUserFunc(userId) }} className="inline-block text-white rounded-lg bg-red-500 px-4 py-2.5 font-semibold text-md capitalize leading-normal">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}

export default DeletePilotConfirmationModal;